import { useTranslate } from '@refinedev/core';

export interface DropdownOption {
  label: string;
  value: string;
}

const useRulesDropdown = () => {
  const t = useTranslate();
  const rulesDropdown: DropdownOption[] = [
    {
      label: t('rulesDropdown.rule1'),
      value: 'rule_1',
    },
    {
      label: t('rulesDropdown.rule2'),
      value: 'rule_2',
    },
    {
      label: t('rulesDropdown.rule3'),
      value: 'rule_3',
    },
    {
      label: t('rulesDropdown.rule4'),
      value: 'rule_4',
    },
    {
      label: t('rulesDropdown.getplan'),
      value: 'get_plan',
    },
  ];

  // Remove drp and key grid only
  const fileType: DropdownOption[] = [
    // {
    //   label: 'Excel',
    //   value: 'excel',
    // },
    {
      label: t('fileType.rule_grid'),
      value: 'dmn',
    },
    {
      label: t('fileType.python'),
      value: 'python',
    },
    {
      label: t('fileType.javascript'),
      value: 'javascript',
    },
  ];
  const ruleType: DropdownOption[] = [
    {
      label: t('ruleType.payout'),
      value: 'payout',
    },
    {
      label: t('ruleType.capping'),
      value: 'capping',
    },
    {
      label: t('ruleType.penalty'),
      value: 'penalty',
    },
    {
      label: t('ruleType.clawback'),
      value: 'clawback',
    },
    {
      label: t('ruleType.boosterContest'),
      value: 'booster_contest',
    },
  ];
  const adjustmentLevel: DropdownOption[] = [
    {
      label: t('adjustmentLevel.transaction'),
      value: 'transaction',
    },
    {
      label: t('adjustmentLevel.group'),
      value: 'group',
    },
  ];
  const editorOptions: DropdownOption[] = [
    {
      value: 'textarea',
      label: t('editorOptions.textarea'),
    },
    {
      value: 'wizard',
      label: t('editorOptions.wizard'),
    },
  ];
  const modeOptions: DropdownOption[] = [
    {
      value: 'single',
      label: t('modeOptions.single'),
    },
    {
      label: t('modeOptions.multiple'),
      value: 'sql',
    },
  ];

  const uploadOptions: DropdownOption[] = [
    {
      label: t('uploadOptions.uploadFile'),
      value: 'upload_file',
    },
    {
      label: t('uploadOptions.newDmn'),
      value: 'new_dmn',
    },
  ];
  const dataType: DropdownOption[] = [
    {
      label: t('dataType.string'),
      value: 'string',
    },
    {
      label: t('dataType.number'),
      value: 'number',
    },
    {
      label: t('dataType.date'),
      value: 'date',
    },
  ];
  return {
    rulesDropdown,
    fileType,
    ruleType,
    adjustmentLevel,
    editorOptions,
    modeOptions,
    uploadOptions,
    dataType,
  };
};

export default useRulesDropdown;
